import { useEffect } from 'react';

/**
 * Detecta swipe horizontal y ejecuta onLeft / onRight
 * Uso:   useSwipe(ref, onLeft, onRight, 50);
 */
export default function useSwipe(ref, onLeft, onRight, threshold = 50) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let x0 = null;

    const onStart = (e) => {
      x0 = e.touches[0].clientX;
    };
    const onMove = (e) => {
      if (x0 === null) return;
      const x1 = e.touches[0].clientX;
      const dx = x1 - x0;
      if (Math.abs(dx) < threshold) return;
      if (dx > 0 && onRight) onRight();
      if (dx < 0 && onLeft) onLeft();
      x0 = null; // consumimos el gesto
    };
    const onEnd = () => (x0 = null);

    el.addEventListener('touchstart', onStart, { passive: true });
    el.addEventListener('touchmove', onMove, { passive: true });
    el.addEventListener('touchend', onEnd, { passive: true });

    return () => {
      el.removeEventListener('touchstart', onStart);
      el.removeEventListener('touchmove', onMove);
      el.removeEventListener('touchend', onEnd);
    };
  }, [ref, onLeft, onRight, threshold]);
}